import type { App } from 'vue'

import type { InfraestruturaAplicacao } from './criar-infraestrutura'
import { instalarEmpregado } from './modulos/empregado.composicao'
import { instalarEmpregador } from './modulos/empregador.composicao'
import { instalarGrupoDeLocaisDeTrabalho } from './modulos/grupo-de-locais-de-trabalho.composicao'
import { instalarLocalDeTrabalho } from './modulos/local-de-trabalho.composicao'
import { instalarMotivoPadrao } from './modulos/motivo-padrao.composicao'
import { instalarPerfilDePermissao } from './modulos/perfil-de-permissao.composicao'
import { instalarRegraDeCalculo } from './modulos/regra-de-calculo.composicao'
import { instalarUsuario } from './modulos/usuario.composicao'

type InstaladorModulo = (
  app: App,
  infraestrutura: InfraestruturaAplicacao,
) => void

const INSTALADORES_MODULOS: readonly InstaladorModulo[] = Object.freeze([
  instalarLocalDeTrabalho,
  instalarEmpregador,
  instalarEmpregado,
  instalarGrupoDeLocaisDeTrabalho,
  instalarPerfilDePermissao,
  instalarUsuario,
  instalarMotivoPadrao,
  instalarRegraDeCalculo,
])

export const instalarModulos = (
  app: App,
  infraestrutura: InfraestruturaAplicacao,
): void => {
  for (const instalarModulo of INSTALADORES_MODULOS) {
    instalarModulo(app, infraestrutura)
  }
}
